import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useToast } from "../other/Toast";
import { classNames } from "primereact/utils";
import { useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useHistory } from "react-router";
import SecurityService from "../service/SecurityService";
import { Tag } from 'primereact/tag'
import { Password } from "primereact/password";
const logo = require('../../cdsc-Blue-Logo.png');

const ChangePassword = () => {
    const toast = useToast();
    const history = useHistory();
    const [opassword, setOpassword] = useState();
    const [password, setPassword] = useState();

    const { control, formState, handleSubmit, reset } = useForm({});
    const errors = formState.errors;
    const getFormErrorMessage = (name) => {
        return errors[name] && <small className="p-error">{errors[name].message}</small>
    };
    const showFormErrorMessage = (message) => {
        return <small className="p-error">{message}</small>
    };

    const lowerCase = (str) => {
        return /[a-z]/g.test(str);
    };
    const upperCase = (str) => {
        return /[A-Z]/g.test(str);
    };
    const isNumber = (str) => {
        var regex = /\d+/g;
        return regex.test(str);
    };
    const isSpecialChar = (str) => {
        return /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(str);
    };
    const islength = (str, len) => {
        return str.length >= len ? true : false;
    };

    const [lowerCaseColor, setLowerCaseColor] = useState("danger");
    const [upperCaseColor, setUpperCaseColor] = useState("danger");
    const [minNumberColor, setMinNumberColor] = useState("danger");
    const [specialCharColor, setSpecialCharColor] = useState("danger");
    const [lengthColor, setLengthColor] = useState("danger");

    const [lowerCaseCheck, setLowerCaseCheck] = useState("pi pi-times");
    const [upperCaseCheck, setUpperCaseCheck] = useState("pi pi-times");
    const [minNumberCheck, setMinNumberCheck] = useState("pi pi-times");
    const [specialCharCheck, setSpecialCharCheck] = useState("pi pi-times");
    const [lengthCheck, setLengthCheck] = useState("pi pi-times");

    const passwordKeyPressed = (event) => {

        if (lowerCase(event.target.value)) {
            setLowerCaseColor("success");
            setLowerCaseCheck("pi pi-check");
        } else {
            setLowerCaseColor("danger");
            setLowerCaseCheck("pi pi-times");
        }

        if (upperCase(event.target.value)) {
            setUpperCaseColor("success");
            setUpperCaseCheck("pi pi-check");
        } else {
            setUpperCaseColor("danger");
            setUpperCaseCheck("pi pi-times");
        }

        if (isNumber(event.target.value)) {
            setMinNumberColor("success");
            setMinNumberCheck("pi pi-check");
        } else {
            setMinNumberColor("danger");
            setMinNumberCheck("pi pi-times");
        }

        if (isSpecialChar(event.target.value)) {
            setSpecialCharColor("success");
            setSpecialCharCheck("pi pi-check");
        } else {
            setSpecialCharColor("danger");
            setSpecialCharCheck("pi pi-times");
        }

        if (islength(event.target.value, 8)) {
            setLengthColor("success");
            setLengthCheck("pi pi-check");
        } else {
            setLengthColor("danger");
            setLengthCheck("pi pi-times");
        }
    };

    return (
        <div
            className="compact-layout landing-page-card"
        >
            <div
                style={{
                    maxWidth: 700,
                    display: "flex",
                    alignContent: "center",
                    justifyContent: "center",
                    placeContent: "center",
                    backgroundColor: "#fff",
                }}
                className="p-col-12"
            >
                <div style={{ padding: 0 }} className="p-col-12">

                    <div
                        className="p-grid p-fluid"
                        style={{ borderBottom: "1px solid #efefef" }}
                    >
                        <div
                            style={{
                                fontSize: 15,
                                textAlign: "center",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                alignContent: 'center',
                                alignItems: 'center',
                                padding: 20,
                            }}
                            className="p-col-12 p-md-12"
                        >
                            <img src="./cdsc-Blue-Logo.png" style={{ height: 50 }} />{" "}
                            <span
                                style={{
                                    paddingLeft: 10,
                                    fontSize: 36,
                                    textAlign: "center",
                                    color: "#008080",
                                    fontFamily: "'Spectral', serif",
                                    transform: 'scale(1.25,1)'
                                }}
                            >
                                CKYC
                            </span>
                        </div>
                        {/* <label className="p-field p-col-12 p-md-12 padding-5" style={{ textAlign: 'center', width: '100%', fontSize: 20, fontWeight: 'bold' }}><i className="pi pi-user-plus"></i> Customer Registration</label> */}
                    </div>
                    <form onSubmit={handleSubmit(data => {
                        SecurityService.changePassword(data.opassword, data.password)
                            .then(response => {
                                if (response && response.data && response.data.data && response.data.data.message)
                                    toast.success("Successful", response.data.data.message);
                                window.location.href = "/kyc/dashboard";
                            })
                            .catch(error => {
                                if (!error || !error.response)
                                    toast.error("Unsuccessful", "Unable to connect to the server");
                                else
                                    switch (error.response.status) {
                                        case 401:
                                            window.location.href = '/login';
                                        case 403:
                                        case 409:
                                        case 400:
                                        case 500:
                                            if (error.response.data.error_description)
                                                toast.error("Unsuccessful", error.response.data.error_description);
                                            else
                                                toast.error("Unsuccessful", 'Internal Server Error');
                                            break;
                                        case 503:
                                            toast.error("Unsuccessful", 'Service Temporarly not available');
                                            break;
                                        default:
                                            toast.error("Unsuccessful", 'Unexpected Error');
                                    }
                            });
                    })}>
                        <div className="p-grid p-fluid" style={{ padding: 20 }}>
                            <div className="p-field p-col-12 p-md-12">
                                <label className="p-col-12"><i className="pi pi-key"></i> Old Password</label>
                                <Controller name="opassword" control={control}
                                    rules={{ required: 'Old password is required.' }}
                                    render={({ field, fieldState }) =>
                                        <Password toggleMask placeholder="Old password" feedback={false} id={field.name} {...field} type="password" className="p-col-12" className={'p-col-12 padding-rl-0 ' + classNames({ 'p-invalid': fieldState.invalid })} />} />
                                {getFormErrorMessage('opassword')}
                            </div>


                            <div className="p-field p-col-12 p-md-12">
                                <label className="p-col-12"><i className="pi pi-key"></i> New Password</label>
                                <Controller name="password" control={control}
                                    rules={{
                                        required: 'Password is required.',
                                        pattern: {
                                            value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/,
                                            message: ""
                                        }
                                    }}
                                    render={({ field, fieldState }) =>
                                        <Password toggleMask placeholder="New password" feedback={false} id={field.name} {...field} type="password" className="p-col-12" className={'p-col-12  padding-rl-0 ' + classNames({ 'p-invalid': fieldState.invalid })}
                                            onKeyUp={(e) => passwordKeyPressed(e)} />} />
                                {getFormErrorMessage('password') || <span></span>}
                                <div className="p-col-12 p-md-12" style={{ padding: '5px 0px', display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
                                    <Tag style={{ margin: 5, fontSize: 11.5, borderRadius: '16px' }} value="Atleast 1 Lowercase required" icon={lowerCaseCheck} severity={lowerCaseColor}></Tag>
                                    <Tag style={{ margin: 5, fontSize: 11.5, borderRadius: '16px' }} value="Atleast 1 Uppercase required" icon={upperCaseCheck} severity={upperCaseColor}></Tag>
                                    <Tag style={{ margin: 5, fontSize: 11.5, borderRadius: '16px' }} value="Atleast 1 Number required" icon={minNumberCheck} severity={minNumberColor}></Tag>
                                    <Tag style={{ margin: 5, fontSize: 11.5, borderRadius: '16px' }} value="Atleast 1 Special Character required" icon={specialCharCheck} severity={specialCharColor}></Tag>
                                    <Tag style={{ margin: 5, fontSize: 11.5, borderRadius: '16px' }} value="Minimum of 8 Characters required" icon={lengthCheck} severity={lengthColor}></Tag>

                                </div>

                            </div>

                            <div className="p-field p-col-12 p-md-12">
                                <label className="p-col-12"><i className="pi pi-key"></i> Confirm New Password</label>
                                <Controller name="rpassword" control={control}
                                    rules={{
                                        required: 'Password confirmation is required.',
                                        validate: (value) => {
                                            console.log(formState, value);
                                            return control._formValues.password === value;
                                        }
                                    }}
                                    render={({ field, fieldState }) =>
                                        <Password toggleMask placeholder="Retype new password" feedback={false} id={field.name} {...field} type="password" className="p-col-12" className={'p-col-12 padding-rl-0 ' + classNames({ 'p-invalid': fieldState.invalid })} />} />
                                {errors.rpassword && errors.rpassword.type === 'validate' && (showFormErrorMessage('Password confirmation does not match with new password')) || getFormErrorMessage('rpassword')}
                            </div>
                            <div className="p-field p-col-12 p-md-12" style={{ paddingTop: 20 }}>
                                <Button type="submit" className="p-col-12" ><span style={{ textAlign: 'center', width: '100%' }} >Change Password</span></Button>
                            </div>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    )
}

export default ChangePassword;